import { Logo } from '@polyai/ui/components/atoms/Logo';
import PolyLoader from '@polyai/ui/components/atoms/PolyLoader';
import Text from '@polyai/ui/components/atoms/Text';
import sizes from '@polyai/ui/styles/config/sizes';

import * as Styled from './ProjectLoading.styled';

const ProjectLoading = ({ loadingText }: { loadingText: string }) => {
  return (
    <Styled.LoadingWrapper>
      <Styled.LoadingSideBar
        style={{
          width: sizes.mainNavWidth,
        }}
      >
        <Styled.LoadingLogo>
          <Logo dotsColor="textPrimaryInverse" />
        </Styled.LoadingLogo>
        <Styled.LoadingBlockWrapper>
          <div style={{ width: 70 }} />
          <div />
          <div />
          <div />
          <div />
          <div />
        </Styled.LoadingBlockWrapper>
        <Styled.LoadingBlockWrapper>
          <div style={{ width: 70 }} />
          <div />
          <div />
        </Styled.LoadingBlockWrapper>
        <Styled.LoadingBlockWrapper>
          <div style={{ width: 70 }} />
          <div />
          <div />
          <div />
        </Styled.LoadingBlockWrapper>
      </Styled.LoadingSideBar>
      <Styled.LoadingContent>
        <Styled.LoadingHeader />
        <Styled.PageLoader>
          <Styled.LogoSpinner>
            <PolyLoader />
          </Styled.LogoSpinner>
          <Text color="textSecondary" variant="bodySemibold">
            Hang tight!
          </Text>
          <Text color="textSecondary" variant="bodySemibold">
            {loadingText}
          </Text>
        </Styled.PageLoader>
      </Styled.LoadingContent>
    </Styled.LoadingWrapper>
  );
};

export default ProjectLoading;
